<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.79333 16.4336V15.149C4.79333 13.3081 6.28572 11.8157 8.12667 11.8157H11.8731C13.7141 11.8157 15.2065 13.3081 15.2065 15.149V16.2433" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/>
        <ellipse cx="9.99992" cy="6.37964" rx="2.81291" ry="2.81275" stroke="currentColor" stroke-width="1.25"/>
    </svg>
</template>
